import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-video-link',
    templateUrl: './video-link.component.html',
    styleUrls: ['./video-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoLinkComponent {
    @Input() href: string;
    @Input() title?: string;
    @Input() text: string;
}
